var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "34px",
    viewBox: "0 0 29 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 34 29 34 29 0 0 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Simple/Train",
    transform: "translate(-9.000000, -7.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(9.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5,20 C9.881,20 11,21.119 11,22.5 C11,23.881 9.881,25 8.5,25 C7.119,25 6,23.881 6,22.5 C6,21.119 7.119,20 8.5,20",
    id: "Fill-1",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5,20 C21.881,20 23,21.119 23,22.5 C23,23.881 21.881,25 20.5,25 C19.119,25 18,23.881 18,22.5 C18,21.119 19.119,20 20.5,20",
    id: "Fill-3",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3122961,14.3163546 L25.3743203,14.3163546 L25.3743203,8.94799002 L16.3122961,8.94799002 L16.3122961,14.3163546 Z M25.3743203,24.1576404 C25.3743203,25.6436038 24.1606855,26.8418227 22.6556043,26.8418227 L6.34330821,26.8418227 C4.83931451,26.8418227 3.62459219,25.6436038 3.62459219,24.1576404 L3.62459219,17.8949064 L25.3743203,17.8949064 L25.3743203,24.1576404 Z M3.62459219,14.3163546 L12.6866164,14.3163546 L12.6866164,8.94799002 L3.62459219,8.94799002 L3.62459219,14.3163546 Z M14.4994563,3.57962548 C20.8612517,3.57962548 23.4897064,4.4385638 24.5956801,5.36836454 L4.40431995,5.36836454 C5.51029362,4.4385638 8.13766078,3.57962548 14.4994563,3.57962548 L14.4994563,3.57962548 Z M14.4994563,0 C7.25027187,0 0,0.895443206 0,7.15817728 L0,24.1576404 C0,27.6116462 2.84595193,30.4214482 6.34330821,30.4214482 L3.62459219,33.1056305 L3.62459219,34 L7.25027187,34 L10.8748641,30.4214482 L18.1251359,30.4214482 L21.7497281,34 L25.3743203,34 L25.3743203,33.1056305 L22.6556043,30.4214482 C26.1540481,30.4214482 29,27.6116462 29,24.1576404 L29,7.15817728 C29,0.895443206 21.7497281,0 14.4994563,0 L14.4994563,0 Z",
    id: "Fill-5",
    fill: "#000000",
    mask: "url(#mask-2)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStation);
export default __webpack_public_path__ + "static/media/station.7305e089.svg";
export { ForwardRef as ReactComponent };